import React, { useState, useEffect } from "react";
import { GetBrandedFooter, GetBrandedCopyright } from "@/services/BrandingService";

export const Footer: React.FC<{authState: string}> = ({ authState }) =>{
  const [footerText, setFooterText] = useState('');
  const [copyrightText, setCopyrightText] = useState('');

  useEffect(() => {
    setFooterText(GetBrandedFooter());
    setCopyrightText(GetBrandedCopyright());
  }, []);

  return (
    authState === "signedIn" ? null :
    <footer className="footer">
      <div className="footerWrapper">
        <span className="footerContent">{footerText}</span>
        <span className="footerContent">{copyrightText}</span>
      </div>
    </footer>
  );
}

export default Footer;